import { defineMessages } from 'react-intl';

export const labelMessages = defineMessages({
  vendorNoLabel: {
    defaultMessage: 'Vendor No.',
    description: 'vendor id grid column text'
  },
  vendorNameLabel: {
    defaultMessage: 'Vendor Name',
    description: 'vendor name grid column text'
  },
  documentIdLabel: {
    defaultMessage: 'Payment No.',
    description: 'documentId grid column text'
  },
  transactionIdLabel: {
    defaultMessage: 'Payable ID',
    description: 'transactionId grid column text'
  },
  amountLabel: {
    defaultMessage: 'Amount($)',
    description: 'amount grid column text'
  },
  failReasonLabel: {
    defaultMessage: 'Fail Reason',
    description: 'payment failReason grid column text'
  },
  failedHeader: {
    defaultMessage: 'Failed',
    description: 'payment failed grid header text'
  },
  successHeader: {
    defaultMessage: 'Complete',
    description: 'payment complete grid header text'
  },
  retrySelected: {
    defaultMessage: 'Retry Selected',
    description: 'retry button text to resubmit the failed records'
  },
  paymentResultDone: {
    defaultMessage: 'Done',
    description: 'payment result done'
  },
  paymentResultPageHeader: {
    defaultMessage: 'Credit Card Payment',
    description: 'payment result page header'
  },
  failedHeaderSubText1: {
    defaultMessage:
      'The following credit card payments failed and no virtual card was created for them. Click ',
    description: 'failed grid header sub text1'
  },
  failedHeaderSubText2: {
    defaultMessage: 'to resend the payment',
    description: 'failed grid header sub text2'
  },
  vendorPaymentFailureDialogTitle: {
    defaultMessage: 'Export/Archive - Credit Card Payment failed',
    description: 'Title for export/archive dialog'
  },
  vendorPaymentSuccessDialogTitle: {
    defaultMessage: 'Export/Archive - Credit Card Payment completed',
    description: 'Title for success payment export/archive dialog'
  },
  creditCardPaymentFailedHeaderTitle: {
    defaultMessage: 'Credit Card Payment Failed Report',
    description: 'credit card payment failed title in export to pdf page'
  },
  creditCardPaymentSuccessHeaderTitle: {
    defaultMessage: 'Credit Card Payment Completed Report',
    description: 'credit card payment completed title in export to pdf page'
  }
});
